import AuditTrail from "../audit.trail";

export const TooltipLog = (WrappedComponent) => (props) => {
  const { afterShow, afterHide, event, eventParams, ...otherProps } = props;

  const onLog = (event, action, eventParams) => {
      if (event && action) {
          AuditTrail.sendLog(event, Object.assign({tag: 'tooltip', event: action, label: props.id? props.id : (props.placeholder? props.placeholder : '')}, eventParams));
      }
  }

  return (
    <WrappedComponent
        {...otherProps}
        afterShow={(context) => {
            onLog(event, 'show', eventParams);
            if (props.afterShow) {
                props.afterShow(context);
            }
        }}
        afterHide={(context) => {
            onLog(event, 'hide', eventParams);
            if (props.afterHide) {
                props.afterHide(context);
            }
        }}
    />
  );
};
